<template>
	<ion-button v-bind="$props" :color="color" fill="clear" size="small" :class="{ loading }">
		<div v-if="loading" :class="`spinner spinner-${color}`"></div>

		<ion-icon :style="{ color: color }" v-if="icon" :src="icon" />

		<span :style="{ color: color }" class="content">
			<slot />
		</span>
	</ion-button>
</template>

<script>
export default {
	props: {
		expand: {
			type: String,
			default: 'default'
		},

		disabled: {
			type: Boolean,
			default: false
		},

		loading: {
			type: Boolean,
			default: false
		},

		icon: {
			type: [String, null],
			default: null
		},

		color: {
			type: String,
			default: 'primary'
		}
	}
}
</script>

<style lang="sass" scoped>
ion-icon
	@apply mr-[7px] mb-[1px]

ion-button
	@apply h-[16px] inline-block -ml-[12px] text-[14px]

	span
		@apply mt-[3px]

	&.loading
		pointer-events: none
		opacity: 0.8

		.content
			opacity: 0.5 !important

		ion-icon
			opacity: 0 !important

.spinner
	display: inline-block
	width: 18px
	height: 18px
	border: 3px solid var(--ion-color-primary-contrast)
	border-top-color: var(--ion-color-primary)
	opacity: 0.8
	border-radius: 50%
	animation: spin 1s linear infinite
	position: absolute
	top: 50%
	left: 10px
	margin-top: -9px
	margin-left: -9px


	&.spinner-danger
		border: 3px solid var(--ion-color-danger-contrast)
		border-top-color: var(--ion-color-danger)

@keyframes spin
	0%
		transform: rotate(0deg)
	50%
		transform: rotate(180deg)

	100%
		transform: rotate(360deg)
</style>
